import { UseQueryOptions } from 'react-query';
import { useAPI } from '@/services/index';
import { preloadImage } from '../hooks/ImagePreloader';

export type TBannerPlace = 'HomePageCenter' | 'Slider' | 'FundPage';
export interface IGetBannerList {
  reactQueryOptions?: UseQueryOptions<any>;
  place: TBannerPlace;
}

export const useGetBannerList = ({
  reactQueryOptions,
  place,
}: IGetBannerList) => {
  const { data, ...rest } = useAPI(['baseInfo', 'getBannerList'], {
    reactQueryOptions: {
      refetchOnWindowFocus: false,
      select(data) {
        return {
          ...data,
          items: data.items.filter((item) => item.contentPlace === place),
        };
      },
      ...(reactQueryOptions || {}),
    },
  });

  return {
    data: data?.items.sort((a, b) => a.displayOrder - b.displayOrder),
    ...rest,
  };
};

interface IStoryQueryParameters {
  page?: string[];
  reactQueryOptions?: UseQueryOptions<any>;
}

export const useGetStories = ({
  page = ['All'],
  reactQueryOptions,
}: IStoryQueryParameters) => {
  const { data, ...rest } = useAPI(['baseInfo', 'getStories'], {
    reactQueryOptions: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        data
          ?.flatMap((story) => story.slides)
          .forEach((slide) => preloadImage(slide.url));
      },
      ...(reactQueryOptions || {}),
    },
  });

  const stories = data?.filter((story) => {
    if (!story.slides.length) return false;
    const arr = story.storyPages.filter(
      (item) => page.includes(item.title) || page.includes(item.tagID)
    );
    return arr.length > 0;
  });

  return {
    data: stories,
    ...rest,
  };
};
